import { render, staticRenderFns } from "./read.vue?vue&type=template&id=25fe7937&scoped=true&"
import script from "./read.vue?vue&type=script&lang=js&"
export * from "./read.vue?vue&type=script&lang=js&"
import style0 from "./read.vue?vue&type=style&index=0&id=25fe7937&prod&scoped=true&lang=css&"
import style1 from "./read.vue?vue&type=style&index=1&id=25fe7937&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe7937",
  null
  
)

export default component.exports